import { render, staticRenderFns } from "./greenReviewed.vue?vue&type=template&id=23b2aa8d"
import script from "./greenReviewed.vue?vue&type=script&lang=js"
export * from "./greenReviewed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports